import React from "react";
import { ManageAdvertisementsContent } from "../components/CMS/Advertisements/ManageAdvertisementsContent";
import { ToastContainer } from "react-toastify";

export const Advertisements = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageAdvertisementsContent />
        </div>
      </div>
    </div>
  );
};
